/**
 * @generated SignedSource<<80e1f280db68d1874af26c56a6dc7cfd>>
 * @relayHash 0f1bccf2abe35a949171f50e2f758ce7
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 0f1bccf2abe35a949171f50e2f758ce7

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ccnId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CcnLinkSettings",
    "kind": "LinkedField",
    "name": "links",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ccnId",
        "variableName": "ccnId"
      }
    ],
    "concreteType": "CcnSettings",
    "kind": "LinkedField",
    "name": "ccnSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CcnOfferTypeSettings",
        "kind": "LinkedField",
        "name": "PREVOYANCE",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CcnOfferTypeSettings",
        "kind": "LinkedField",
        "name": "SANTE",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "0f1bccf2abe35a949171f50e2f758ce7",
    "metadata": {},
    "name": "SettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "21e16f62c8efeb3ec3f036d4501cfa40";

export default node;
